var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPortraitPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3447 82.4532V72.2252C79.6458 71.0845 86.2274 63.2503 86.9174 57.1291C88.7276 56.9909 91.5715 55.3289 92.4101 48.7679C92.8601 45.2444 91.0703 43.2654 89.9856 42.6415C89.9856 42.6415 92.6863 37.5123 92.6863 31.3195C92.6863 18.903 87.8126 8.30715 77.3447 8.30715C77.3447 8.30715 73.7085 0.636353 62.0029 0.636353C40.3099 0.636353 31.3198 14.5512 31.3198 31.3195C31.3198 36.9651 34.0199 42.6415 34.0199 42.6415C32.9358 43.2654 31.146 45.2496 31.596 48.7679C32.4346 55.3289 35.2779 56.9909 37.0882 57.1291C37.7786 63.2503 44.3601 71.0845 46.6614 72.2252V82.4532C41.5475 97.7941 0.636719 87.5668 0.636719 123.364H123.369C123.369 87.5668 82.4583 97.7941 77.3447 82.4532Z",
    fill: "#7FCC26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPortraitPlaceholder);
export default __webpack_public_path__ + "static/media/user-portrait-placeholder.424a774702675b0786179dd6a65fb1fc.svg";
export { ForwardRef as ReactComponent };